export const ISSUES_TAB_SELECTOR = 'ul.workspace__tabs a[href="#iim-issues"]';
/**
 * Switches the server-rendered Bootstrap workspace tabs to the IIM issues tab.
 * Clicking the anchor runs Bootstrap's data-api handler (the same `tab('show')` path),
 * so `shown.bs.tab` listeners still fire without depending on jQuery.
 * No-op when the tab is not rendered.
 */
export function activateIssuesTab() {
    var _a;
    (_a = document.querySelector(ISSUES_TAB_SELECTOR)) === null || _a === void 0 ? void 0 : _a.click();
}
